"use strict";

// Mobile Swiper Product Gallery Handler
Shopify.theme.jsSwiperProduct = {
	mobileSwiper: null,
	thumbnailSwiper: null,
	originalSlides: {
		main: [],
		thumbnails: [],
	},

	// Initialize mobile gallery with thumbnails
	init: function (settings) {
		// Only initialize on mobile
		if (window.innerWidth > 798) {
			return;
		}

		// Store reference to main instance for callbacks
		let self = this;

		// Get settings from liquid or use defaults
		this.settings = {
			displayThumbnails: settings.displayThumbnails || false,
			enableThumbnailSlider: settings.enableThumbnailSlider || false,
			productId: settings.productId || null,
			mediaCount: settings.mediaCount || 0,
		};

		// Only proceed if thumbnails are enabled
		if (!this.settings.displayThumbnails || this.settings.mediaCount <= 1) {
			this.initMainSwiper();
			return;
		}

		// Store original slide data before initializing swipers
		this.storeOriginalSlides();

		// Initialize thumbnails first, then main swiper
		this.initThumbnails();
		this.initMainSwiper();

		// Set up event listeners
		this.setupEventListeners();
		this.setupNavigationButtons();

		// Delay initial filtering to ensure swipers are fully ready
		setTimeout(() => {
			// Try to get the currently selected variant and apply filtering
			this.applyInitialFiltering();

			// Initialize counter on load
			if (this.mobileSwiper) {
				this.updateImageCounter(this.mobileSwiper);
			}
		}, 200);
	},

	// Store original slide HTML data for rebuild approach
	storeOriginalSlides: function () {
		// Store main slides
		let mainSlides = document.querySelectorAll(
			".productsMobile .swiper-slide"
		);
		this.originalSlides.main = Array.from(mainSlides).map(slide => ({
			html: slide.outerHTML,
			color: slide.getAttribute("thumbnail-color"),
			imageId: slide
				.querySelector("img[data-image-id]")
				?.getAttribute("data-image-id"),
		}));

		// Store thumbnail slides
		let thumbnailSlides = document.querySelectorAll(
			".productsMobileThumbnails .swiper-slide"
		);
		this.originalSlides.thumbnails = Array.from(thumbnailSlides).map(
			slide => ({
				html: slide.outerHTML,
				color: slide.getAttribute("thumbnail-color"),
				imageId: slide.querySelector("img")?.getAttribute("src"),
			})
		);
	},

	// Apply initial filtering based on currently selected variant
	applyInitialFiltering: function () {
		// Try to get the currently selected variant from various sources
		let selectedColor = null;
		let selectedImageId = null;

		// Method 1: Check for selected option in variant selector
		let variantSelector = document.querySelector("[data-variant-selector]");
		if (variantSelector) {
			let selectedOption =
				variantSelector.querySelector("option:checked") ||
				variantSelector.querySelector("[selected]");
			if (selectedOption && selectedOption.value) {
				selectedImageId = selectedOption.getAttribute("data-image-id");
				selectedColor = selectedOption.getAttribute("data-thumbnail-color");
			}
		}

		// Method 2: Check for first available variant if no selection
		if (!selectedColor) {
			let firstOption = document.querySelector(
				'[data-variant-selector] option[value]:not([value=""])'
			);
			if (firstOption) {
				selectedImageId = firstOption.getAttribute("data-image-id");
				selectedColor = firstOption.getAttribute("data-thumbnail-color");
			}
		}

		// Apply filtering if we have a color
		if (selectedColor) {
			this.rebuildSwipers(selectedColor, selectedImageId);
		} else {
			this.rebuildSwipersWithAllSlides();
		}
	},

	// Initialize main mobile swiper
	initMainSwiper: function () {
		let self = this;

		// Main swiper configuration
		let mainConfig = {
			slidesPerView: 1,
			spaceBetween: 5,
			centeredSlides: true,
			scrollbar: {
				el: ".mobile-scrollbar-container .swiper-scrollbar",
				draggable: true,
			},
			on: {
				slideChange: function () {
					self.handleSlideChange(this);
					self.updateImageCounter(this);
					// Thumbnail syncing handled by thumbs module
				},
			},
		};

		// Add thumbs module if thumbnails exist
		if (this.thumbnailSwiper) {
			mainConfig.thumbs = {
				swiper: this.thumbnailSwiper,
				slideThumbActiveClass: "swiper-slide-thumb-active",
			};
			// Keep scrollbar even with thumbnails
		}

		this.mobileSwiper = new Swiper(".productsMobile", mainConfig);
	},

	// Initialize thumbnail swiper
	initThumbnails: function () {
		// Check if thumbnail container exists
		if (!document.querySelector(".productsMobileThumbnails")) {
			return;
		}

		this.thumbnailSwiper = new Swiper(".productsMobileThumbnails", {
			slidesPerView: 6,
			spaceBetween: 8,
			watchSlidesProgress: true,
			centerInsufficientSlides: false,
			freeMode: true,
			// Remove custom click handler - let thumbs module handle navigation
		});
	},

	// Handle slide change events
	handleSlideChange: function (swiper) {
		let activeSlide = swiper.slides[swiper.activeIndex];
		if (!activeSlide) return;

		// Handle media-specific actions (video, model, etc.)
		let mediaType = activeSlide.getAttribute("data-media-type");

		// Pause videos in inactive slides
		this.pauseInactiveMedia(swiper);

		// Play active media if applicable
		if (mediaType === "video" || mediaType === "external_video") {
			this.playActiveVideo(activeSlide);
		}
	},

	// Update image counter display - simplified for rebuild approach
	updateImageCounter: function (swiper) {
		let counter = document.getElementById("mobile-image-counter");
		if (counter && swiper) {
			// With rebuild approach, all slides are visible and properly indexed
			let totalSlides = swiper.slides.length;
			let currentSlideIndex = swiper.activeIndex + 1; // Convert to 1-based for display

			// Validate the activeIndex
			if (currentSlideIndex > totalSlides || currentSlideIndex < 1) {
				currentSlideIndex = 1;
			}

			counter.textContent = currentSlideIndex + "/" + totalSlides;
		}
	},

	// Set up variant and other event listeners
	setupEventListeners: function () {
		// Event listeners are now set up in product__images.liquid
		// to properly integrate with the existing selectCallback system
	},

	// Set up navigation button event listeners
	setupNavigationButtons: function () {
		let self = this;

		// Previous button
		let prevButton = document.querySelector(".mobile-nav-prev");
		if (prevButton) {
			prevButton.addEventListener("click", function () {
				if (self.mobileSwiper) {
					self.mobileSwiper.slidePrev();
				}
			});
		}

		// Next button
		let nextButton = document.querySelector(".mobile-nav-next");
		if (nextButton) {
			nextButton.addEventListener("click", function () {
				console.log("[jsSwiperProduct] Next button clicked");
				if (self.mobileSwiper) {
					self.mobileSwiper.slideNext();
				}
			});
		}
	},

	// Handle variant change
	handleVariantChange: function (detail) {
		console.log("[jsSwiperProduct] handleVariantChange called with:", detail);
		if (!detail) return;

		// Extract color from variant detail
		let color =
			detail.thumbnailColor ||
			(detail.variant && detail.variant.option1) ||
			null;

		// Get variant image ID from event detail
		let imageId =
			detail.imageId || detail.featured_image_id || detail.image_id;

		// If we have a color, rebuild swipers to show only matching variant slides
		if (color) {
			this.rebuildSwipers(color, imageId);
		} else if (imageId) {
			// No color but have image ID, show all slides and navigate to that image
			this.rebuildSwipersWithAllSlides();
			setTimeout(() => {
				this.navigateToImage(imageId);
			}, 200); // Increased delay for rebuild
		} else {
			// No color or image ID, show all slides
			this.rebuildSwipersWithAllSlides();
		}
	},

	// Handle variant selection from dropdown
	handleVariantSelection: function (variantId) {
		let selector = document.querySelector("[data-variant-selector]");
		if (!selector) return;

		let selectedOption = selector.querySelector(
			'option[value="' + variantId + '"]'
		);
		if (!selectedOption) return;

		let imageId = selectedOption.getAttribute("data-image-id");
		let thumbnailColor = selectedOption.getAttribute("data-thumbnail-color");

		if (imageId) {
			this.navigateToImage(imageId);
		}

		if (thumbnailColor) {
			this.rebuildSwipers(thumbnailColor, imageId);
		}
	},

	// Navigate to specific image by ID
	navigateToImage: function (imageId) {
		if (!this.mobileSwiper) {
			return;
		}

		if (!imageId) {
			return;
		}

		// Find slide with matching image ID
		let slides = this.mobileSwiper.slides;

		for (let i = 0; i < slides.length; i++) {
			let slide = slides[i];

			// Look for image with matching data-image-id attribute
			let matchingImg = slide.querySelector(
				'img[data-image-id="' + imageId + '"]'
			);

			// Also check if image ID matches the img element's id
			if (!matchingImg) {
				matchingImg = slide.querySelector('img[id="' + imageId + '"]');
			}

			if (matchingImg) {
				this.mobileSwiper.slideTo(i);

				// Update counter immediately
				this.updateImageCounter(this.mobileSwiper);

				// Also update thumbnail if it exists
				if (this.thumbnailSwiper) {
					// Calculate position to center the selected thumbnail
					let centerPosition = i - Math.floor(4.5 / 2); // 4.5 slides per view, center at middle
					if (centerPosition < 0) centerPosition = 0;

					this.thumbnailSwiper.slideTo(centerPosition, 300);
				}
				return;
			}
		}
	},

	// Navigate to first image of specified color - now uses filtering first
	navigateToFirstColorImage: function (color, featuredImageId) {
		if (!this.mobileSwiper || !color) {
			return;
		}

		// Rebuild swipers first to show only relevant ones
		this.rebuildSwipers(color, featuredImageId);
	},

	// Filter media by variant color
	filterMediaByColor: function (variant) {
		// Try to get color from variant options
		let color = null;

		if (variant.options && variant.options.length > 0) {
			// Usually color is the first option
			color = variant.options[0];
		} else if (variant.option1) {
			color = variant.option1;
		}

		// Try to get featured image ID
		let featuredImageId = variant.featured_media
			? variant.featured_media.id
			: variant.featured_image
			? variant.featured_image.id
			: null;

		if (color) {
			this.rebuildSwipers(color, featuredImageId);
		}
	},

	// Pause videos in inactive slides
	pauseInactiveMedia: function (swiper) {
		// This would integrate with video player instances
		// Placeholder for video pause logic
		let inactiveSlides = swiper.slides.filter(function (slide, slideIndex) {
			return slideIndex !== swiper.activeIndex;
		});

		inactiveSlides.forEach(function (slide) {
			let video = slide.querySelector("video");
			if (video) {
				video.pause();
			}
		});
	},

	// Play video in active slide
	playActiveVideo: function (slide) {
		// Placeholder for video autoplay logic
		// Would integrate with Plyr or native video
		let video = slide.querySelector("video");
		if (video && video.paused) {
			// Check autoplay settings before playing
			// video.play();
		}
	},

	// Rebuild swipers with filtered slides - replaces filterSlidesByColor
	rebuildSwipers: function (color, featuredImageId) {
		if (!color) {
			this.rebuildSwipersWithAllSlides();
			return;
		}

		// Filter slide data arrays
		let filteredData = this.getFilteredSlideData(color, featuredImageId);

		// Rebuild swipers with filtered slides
		this.destroyAndRebuildSwipers(filteredData);
	},

	// Get filtered slide data based on color and featured image
	getFilteredSlideData: function (color, featuredImageId) {
		// Normalize the color format
		let targetColor =
			"#color_" +
			color.toLowerCase().replace(/\s+/g, "_").replace(/-/g, "_");

		let filteredMain = [];
		let filteredThumbnails = [];

		// Filter main slides with strict matching logic
		this.originalSlides.main.forEach(function (slideData) {
			let shouldInclude = false;

			// Check if this is the featured image
			if (slideData.imageId && featuredImageId) {
				if (slideData.imageId === String(featuredImageId)) {
					shouldInclude = true;
				}
			}

			// Check color match
			if (!shouldInclude && slideData.color) {
				let cleanColor = slideData.color.toLowerCase().replace(/-/g, "_");

				if (cleanColor === targetColor) {
					shouldInclude = true;
				}
			}

			if (shouldInclude) {
				filteredMain.push(slideData);
			}
		});

		// Filter thumbnail slides with same logic
		this.originalSlides.thumbnails.forEach(function (slideData) {
			let shouldInclude = false;

			// Check if this thumbnail has the featured image
			if (slideData.imageId && featuredImageId) {
				if (slideData.imageId.includes(String(featuredImageId))) {
					shouldInclude = true;
				}
			}

			// Check color match
			if (!shouldInclude && slideData.color) {
				let cleanColor = slideData.color.toLowerCase().replace(/-/g, "_");

				if (cleanColor === targetColor) {
					shouldInclude = true;
				}
			}

			if (shouldInclude) {
				filteredThumbnails.push(slideData);
			}
		});

		return {
			main: filteredMain,
			thumbnails: filteredThumbnails,
		};
	},

	// Destroy existing swipers and rebuild with new slide data
	destroyAndRebuildSwipers: function (slideData) {
		// Destroy existing swipers
		if (this.mobileSwiper) {
			this.mobileSwiper.destroy(true, true);
			this.mobileSwiper = null;
		}
		if (this.thumbnailSwiper) {
			this.thumbnailSwiper.destroy(true, true);
			this.thumbnailSwiper = null;
		}

		// Clear existing slide containers
		let mainContainer = document.querySelector(
			".productsMobile .swiper-wrapper"
		);
		let thumbContainer = document.querySelector(
			".productsMobileThumbnails .swiper-wrapper"
		);

		if (mainContainer) mainContainer.innerHTML = "";
		if (thumbContainer) thumbContainer.innerHTML = "";

		// Add filtered slides to containers
		slideData.main.forEach(function (slideData) {
			if (mainContainer) {
				mainContainer.insertAdjacentHTML("beforeend", slideData.html);
			}
		});

		slideData.thumbnails.forEach(function (slideData) {
			if (thumbContainer) {
				thumbContainer.insertAdjacentHTML("beforeend", slideData.html);
			}
		});

		// Rebuild swipers with new slides
		this.initThumbnails();
		this.initMainSwiper();

		// Update counter
		if (this.mobileSwiper) {
			// Small delay to ensure swiper is fully initialized
			setTimeout(() => {
				this.updateImageCounter(this.mobileSwiper);
			}, 100);
		}
	},

	// Rebuild swipers with all original slides (no filtering)
	rebuildSwipersWithAllSlides: function () {
		this.destroyAndRebuildSwipers({
			main: this.originalSlides.main,
			thumbnails: this.originalSlides.thumbnails,
		});
	},

	// Destroy swipers (for cleanup)
	destroy: function () {
		if (this.mobileSwiper) {
			this.mobileSwiper.destroy();
			this.mobileSwiper = null;
		}

		if (this.thumbnailSwiper) {
			this.thumbnailSwiper.destroy();
			this.thumbnailSwiper = null;
		}
	},

	// Update swipers after DOM changes
	update: function () {
		if (this.mobileSwiper) {
			this.mobileSwiper.update();
		}

		if (this.thumbnailSwiper) {
			this.thumbnailSwiper.update();
		}
	},
};
